/**
 * author: liyuan1@jpush.cn
 */
export * from './switch.module';
